import React from "react";
import { TextField, Stack } from "@mui/material";

export const Panorama = ({ value, onChange }) => {
  return (
    <Stack spacing={2} mt={4}>
      <TextField
        fullWidth
        multiline
        minRows={3}
        maxRows={16}
        label="Escribe tu panorama"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        sx={{
          "& .MuiInputBase-root": {
            alignItems: "flex-start",
          },
          "& textarea": {
            overflowY: {
              xs: "visible",
              md: "auto",
            },
          },
        }}
      />
    </Stack>
  );
};
